import { render, staticRenderFns } from "./MailTemplateEdit.vue?vue&type=template&id=b138e2c0"
import script from "./MailTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./MailTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./MailTemplateEdit.vue?vue&type=style&index=0&id=b138e2c0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b138e2c0')) {
      api.createRecord('b138e2c0', component.options)
    } else {
      api.reload('b138e2c0', component.options)
    }
    module.hot.accept("./MailTemplateEdit.vue?vue&type=template&id=b138e2c0", function () {
      api.rerender('b138e2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail-template-editor/MailTemplateEdit.vue"
export default component.exports